import React, { useEffect, useRef, useState } from 'react';
import Cookies from "js-cookie";
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { getGameStatus } from '../gameSlice';
import useDisableBrowserBack from "../../hooks/useDisableBrowserBack";
import useReadCookies from "../../hooks/useReadCookies";
import Timer from '../shared/timer';

function TimesUp() {
  useDisableBrowserBack();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  let { cookieGroupId } = useReadCookies();
  const [startOutro, setStartOutro] = useState(false);

  useEffect(() => {
    document.querySelector('meta[name="theme-color"]').setAttribute('content', '#292929');
    dispatch(getGameStatus(cookieGroupId));
  }, []);


  useEffect(() => {
    let outroTimeout;
    if (startOutro) {
      outroTimeout = setTimeout(() => {
        navigate("/app/game/missionsSummary" + window.location.search);
      }, 500);
    }
    return () => {
      if (outroTimeout) {
        clearTimeout(outroTimeout);
      }
    }
  }, [startOutro]);

  const handleContinueButton = (e) => {
    e.preventDefault();
    setStartOutro(true);
  }

  return (
    <div className='mobileContainer backgroundGold timesup-screen'>
      <div className="appHeader">
        <Timer/>
      </div>
      <div className="content-wrapper">
        <div className={`content-1 frameExpressive _anim-in ${startOutro ? '_anim-out' : ''}`}>
          <h3>{t("student.times_up.title")}</h3>
          <p>{t("student.times_up.message_1")}</p>
        </div>
        <div className={`content-2 speechBalloonSmall _anim-in ${startOutro ? '_anim-out' : ''}`}>
          <p>{t("student.times_up.message_2")}</p>
        </div>
      </div>
      <div className={`navigationDrawer spread variant6 enableInAnimation`}>
        <span>&nbsp;</span>
        <a className="chromelessIconButton" onClick={handleContinueButton}>
          <span className="caption">{t("student.times_up.button_text")}</span>
          <span className="icon icon-forward"></span>
        </a>
      </div>
    </div>
  );
}

export default TimesUp;